import { MenuItem, Select, SelectProps } from '@mui/material';
import { FieldProps, getIn } from 'formik';
import React from 'react';
import { FormFieldWrapper } from 'src/shared/Forms/FormFieldWrapper';

export interface Option {
  value: string;
  label: string;
}

export interface FormSelectProps extends Omit<SelectProps, 'name' | 'value'> {
  name: string;
  options: Option[];
  label?: string;
  helperText?: string;
  prompt?: string;
}

export const FormSelect: React.FC<FormSelectProps> = ({
  name,
  options,
  label,
  helperText,
  size,
  prompt,
  ...props
}) => {
  return (
    <FormFieldWrapper name={name} label={label} helperText={helperText}>
      {({ field, form }: FieldProps) => {
        const error = getIn(form.errors, name);
        const touched = getIn(form.touched, name);
        const showError = Boolean(error && touched);

        const promptLabel = prompt ? (
          <MenuItem value={''}>{prompt}</MenuItem>
        ) : null;

        return (
          <Select
            {...field}
            {...props}
            error={showError}
            size={size || 'small'}
            fullWidth
            sx={{ py: 1 }}
          >
            {promptLabel}
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        );
      }}
    </FormFieldWrapper>
  );
};
